






































































import Component from "vue-class-component";
import Vue from "vue";
import { Prop, Watch } from "vue-property-decorator";
import IEventBrandingDto from "@/chipply/IEventBrandingDto";
import { DealerLogoDisplay } from "../../../../common";

@Component
export default class StoreFooter extends Vue {
    public name = "StoreFooter";
    public DealerLogoDisplay = DealerLogoDisplay;

    // eslint-disable-next-line
    @Prop({ type: Object, default: () => {} })
    public branding!: IEventBrandingDto;
}
